import { render } from "./UserIp.vue?vue&type=template&id=2abd65b2"
import script from "./UserIp.vue?vue&type=script&lang=js"
export * from "./UserIp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__